import topic from '../topic'
export const psinAPI = {
    getPsins: topic.psinTopic + '/get_psins',
    getPsinById: topic.psinTopic + '/get_psin_by_id',
    addPsin: topic.psinTopic + '/add_psin',
    editPsin: topic.psinTopic + '/edit_psin',
    deletePsinByIds: topic.psinTopic + '/delete_psin_by_ids'
}